let goods = [
  {
    path: 'goodsMgt',
    meta: {
      title: '商品管理',
      breadcrumb: true
    },
    component: {
      name: 'goodsMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '商品管理',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt/children/editor'], resolve)
      },
    ]
  },
  {
    path: 'rwllClassify',
    meta: {
      title: '耳纹理疗分类',
      breadcrumb: true
    },
    component: {
      name: 'rwllClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '耳纹理疗分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/rwllClassify'], resolve),
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/rwllClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'yyslClassify',
    meta: {
      title: '营养食疗分类',
      breadcrumb: true
    },
    component: {
      name: 'yyslClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '营养食疗分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yyslClassify'], resolve)
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yyslClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'mwwdProduct',
    meta: {
      title: '云仓商品管理',
      breadcrumb: true
    },
    component: {
      name: 'mwwdProduct',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        meta: {
          title: '云仓商品管理',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/mwwdProduct'], resolve)
      },
      {
        path: 'operating',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/mwwdProduct/operating'], resolve)
      },
      {
        path: 'productGroup',
        meta: {
          title: "打包产品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/mwwdProduct/productGroup'], resolve)
      }
    ]
  },
  {
    path: 'activationCode',
    meta: {
      title: '光明使者激活码',
      breadcrumb: true
    },
    component: {
      name: 'activationCode',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '光明使者激活码',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activationCode'], resolve)
      },
      {
        path: 'actionPage',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activationCode/actionPage'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activationCode/detail'], resolve)
      }
    ]
  },
  {
    path: 'activateCodeList',
    meta: {
      title: '激活码列表',
      breadcrumb: true
    },
    component: {
      name: 'activateCodeList',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '激活码列表',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activateCodeList'], resolve)
      },
    ]
  },
]

export default {
  path: '/goodsManagement',
  redirect: '/goodsManagement/goodsMgt',
  meta: {
      title: "商品管理",
      breadcrumb: true
  },
  component: {
      name: 'goodsManagement',
      template: '<router-view></router-view>'
  },
  children: goods
}


// WEBPACK FOOTER //
// ./src/router/goodsManagement.js